import { render, staticRenderFns } from "./vupload.vue?vue&type=template&id=70b55097&scoped=true&"
import script from "./vupload.vue?vue&type=script&lang=js&"
export * from "./vupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b55097",
  null
  
)

export default component.exports